<script setup lang="ts">
const route = useRoute();
const isHeaderFixed = computed(() => route.meta.fixedHeader === true);
</script>
<template>
	<div class="min-h-screen" :class="{ 'pt-[60px] lg:pt-20': isHeaderFixed }">
		<PortalHeader
			variant="primary"
			:fixed="isHeaderFixed"
			:class="[
				'h-[60px] lg:h-20',
				isHeaderFixed ? 'fixed left-0 top-0 z-[100] w-full' : ''
			]"
		/>

		<main class="box-border size-full">
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSectionNavigation />
		</Container>
		<Container class="bg-primary py-0!">
			<PortalFooter />
		</Container>
	</div>
</template>
